module.exports = __webpack_public_path__ + "static/media/HeaderScreen.436cb7a3.png";